// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/build/js/main.script": 0,
	"components/auto-toc/auto-toc": 0,
	"components/ai-search-summary/ai-search-summary": 0,
	"src/libraries/iframe-handler/iframe-styles": 0,
	"src/libraries/hide-navbar/hide-navbar": 0,
	"components/views-view/views-view": 0,
	"components/views-documents/views-documents": 0,
	"components/topbar/topbar": 0,
	"components/timeseries-download-modal/timeseries-download-modal": 0,
	"components/ai-search-result-card/ai-search-result-card": 0,
	"components/taxonomy/taxonomy": 0,
	"components/splide/splide": 0,
	"components/separator/separator": 0,
	"components/select/select": 0,
	"components/sectioned-page/sectioned-page": 0,
	"components/report-tabs/report-tabs": 0,
	"components/qlik-fallback/qlik-fallback": 0,
	"components/pdf-embedded/pdf-embedded": 0,
	"components/paragraph/paragraph": 0,
	"components/paragraph-title-text-with-video/paragraph-title-text-with-video": 0,
	"components/accordion/accordion": 0,
	"components/paragraph--tourism-gateway/paragraph--tourism-gateway": 0,
	"components/paragraph--sources-contributors/paragraph--sources-contributors": 0,
	"components/paragraph--sources-contributors-card/paragraph--sources-contributors-card": 0,
	"components/paragraph--section-insto/paragraph--section-insto": 0,
	"components/paragraph--purpose/paragraph--purpose": 0,
	"components/paragraph--mision-vision-card/paragraph--mision-vision-card": 0,
	"components/paragraph--list-numeric/paragraph--list-numeric": 0,
	"components/paragraph--list-integer-card/paragraph--list-integer-card": 0,
	"components/paragraph--institutional-video/paragraph--institutional-video": 0,
	"components/paragraph--hero/paragraph--hero": 0,
	"build/css/main.style": 0,
	"components/paragraph--gateway-card/paragraph--gateway-card": 0,
	"components/paragraph--category/paragraph--category": 0,
	"components/paragraph--category-cards/paragraph--category-cards": 0,
	"components/paragraph--banner/paragraph--banner": 0,
	"components/page/page": 0,
	"components/page-title/page-title": 0,
	"components/page-navigation/page-navigation": 0,
	"components/page-footer/page-footer": 0,
	"components/page-content/page-content": 0,
	"components/node/node": 0,
	"components/node-highlight/node-highlight": 0,
	"components/navbar/navbar": 0,
	"components/navbar-brand/navbar-brand": 0,
	"components/nav/nav": 0,
	"components/modal/modal": 0,
	"components/megamenu/megamenu": 0,
	"components/media/media": 0,
	"components/media-video/media-video": 0,
	"components/media--icon-social-media/media--icon-social-media": 0,
	"components/media--hero-imagen/media--hero-imagen": 0,
	"components/market-facet/market-facet": 0,
	"components/language-switcher/language-switcher": 0,
	"components/language-switcher-stacked/language-switcher-stacked": 0,
	"components/language-switcher-dropdown/language-switcher-dropdown": 0,
	"components/input/input": 0,
	"components/indicator-card/indicator-card": 0,
	"components/image/image": 0,
	"components/icon/icon": 0,
	"components/icon-link/icon-link": 0,
	"components/html/html": 0,
	"components/hero-slider/hero-slider": 0,
	"components/heading/heading": 0,
	"components/form/form": 0,
	"components/form-element/form-element": 0,
	"components/filters-offcanvas/filters-offcanvas": 0,
	"components/field/field": 0,
	"components/facets-view-mode/facets-view-mode": 0,
	"components/facet-dropdown/facet-dropdown": 0,
	"components/empty-state/empty-state": 0,
	"components/dropdown/dropdown": 0,
	"components/document-search-index/document-search-index": 0,
	"components/document-preview/document-preview": 0,
	"components/document-full/document-full": 0,
	"components/compact-list/compact-list": 0,
	"components/carousel-card/carousel-card": 0,
	"components/carousel-card-latest/carousel-card-latest": 0,
	"components/card/card": 0,
	"components/button/button": 0,
	"components/breadcrumb/breadcrumb": 0,
	"components/block/block": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkteide"] = self["webpackChunkteide"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));